/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type pin_FullMilestone$ref = any;
export type pin_pinMilestoneAction_MutationVariables = {|
  itemId: any
|};
export type pin_pinMilestoneAction_MutationResponse = {|
  +pinMutation: ?{|
    +pin: ?{|
      +id: string,
      +milestones: $ReadOnlyArray<?{|
        +id: string,
        +$fragmentRefs: pin_FullMilestone$ref,
      |}>,
    |}
  |}
|};
export type pin_pinMilestoneAction_Mutation = {|
  variables: pin_pinMilestoneAction_MutationVariables,
  response: pin_pinMilestoneAction_MutationResponse,
|};
*/


/*
mutation pin_pinMilestoneAction_Mutation(
  $itemId: UUID!
) {
  pinMutation {
    pin(itemId: $itemId, itemType: MilestoneAction) {
      id
      milestones {
        id
        ...pin_FullMilestone
      }
    }
  }
}

fragment pin_FullMilestone on Milestone {
  id
  name
  description
  track
  dueDate
  completedDate
  status
  planTemplateName
  actions {
    id
    text
    status
    pinned
    auditMeta {
      created
      createdBy {
        userName
        firstName
        lastName
        id
      }
      updated
      updatedBy {
        userName
        firstName
        lastName
        id
      }
    }
    milestoneTemplateName
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "itemId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "itemId",
    "variableName": "itemId"
  },
  {
    "kind": "Literal",
    "name": "itemType",
    "value": "MilestoneAction"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  },
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pin_pinMilestoneAction_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PinMutation",
        "kind": "LinkedField",
        "name": "pinMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "pin",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Milestone",
                "kind": "LinkedField",
                "name": "milestones",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "pin_FullMilestone"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pin_pinMilestoneAction_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PinMutation",
        "kind": "LinkedField",
        "name": "pinMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "pin",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Milestone",
                "kind": "LinkedField",
                "name": "milestones",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "track",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dueDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "completedDate",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planTemplateName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MilestoneAction",
                    "kind": "LinkedField",
                    "name": "actions",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pinned",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuditMeta",
                        "kind": "LinkedField",
                        "name": "auditMeta",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "created",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AuditUser",
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": (v4/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "updated",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AuditUser",
                            "kind": "LinkedField",
                            "name": "updatedBy",
                            "plural": false,
                            "selections": (v4/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "milestoneTemplateName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cf94a6334916b7758db7167a8aa48e3c",
    "id": null,
    "metadata": {},
    "name": "pin_pinMilestoneAction_Mutation",
    "operationKind": "mutation",
    "text": "mutation pin_pinMilestoneAction_Mutation(\n  $itemId: UUID!\n) {\n  pinMutation {\n    pin(itemId: $itemId, itemType: MilestoneAction) {\n      id\n      milestones {\n        id\n        ...pin_FullMilestone\n      }\n    }\n  }\n}\n\nfragment pin_FullMilestone on Milestone {\n  id\n  name\n  description\n  track\n  dueDate\n  completedDate\n  status\n  planTemplateName\n  actions {\n    id\n    text\n    status\n    pinned\n    auditMeta {\n      created\n      createdBy {\n        userName\n        firstName\n        lastName\n        id\n      }\n      updated\n      updatedBy {\n        userName\n        firstName\n        lastName\n        id\n      }\n    }\n    milestoneTemplateName\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '27bde129846301255bcb4ad755307f86';

module.exports = node;
